import { createContext } from 'react';

type LayoutPreferenceContextValue = {
  isMenuPinnedOpen: boolean;
  isTabletMenuOpen: boolean;
  setIsMenuPinnedOpen: (nextValue: boolean) => void;
  setIsTabletMenuOpen: (nextValue: boolean) => void;
  setTabletMenuItemId: (nextValue: string | null) => void;
  tabletMenuItemId: string | null;
};

export const LayoutPreferenceContext =
  createContext<LayoutPreferenceContextValue | null>(null);
